// Link to an artist's page. The name keeps the URL readable; the id (?id=)
// is what ArtistPage resolves by when present. Use it wherever the name comes
// from a SAVED copy (co-signs, rankings) rather than fresh data: an artist can
// be renamed after it was saved (admin correction or the artist editing their
// own name), and a name-only link then lands on "Artist not found".
export function artistPath(name, artistKey) {
  const base = `/artist/${encodeURIComponent(name || "")}`;
  return artistKey ? `${base}?id=${encodeURIComponent(artistKey)}` : base;
}
